import React, { Component } from "react";
import { Link } from "react-router-dom";
// import LoadingPage from "../../components/Loading/Loading";
import Table from "../../components/Table/TableStaff";
// import config from "../../config";
// import errorFunctions from "../../store/errorFunctions";
import "../common.css";
import "./ManageStaff.css";

export default class ManageStaff extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      staff: [],
      searchFilter: "",
    };
  }

  render() {
    const tableHead = [
      {
        id: "name",
        label: "Name",
        valueDisplay: (value) => value || "",
      },
      {
        id: "email",
        label: "email",
        valueDisplay: (value) => value || "email empty",
      },
      {
        id: "user_role",
        label: "User Role",
        valueDisplay: (value) => value || "",
      },
      {
        id: "brands",
        label: "Brands",
        valueDisplay: (value) => value || "",
      },
      {
        id: "service_center",
        label: "Service Center Count",
        valueDisplay: (value) => value || "",
      },
      {
        id: "action",
        label: "Action",
        valueDisplay: (value) => value || "",
      },
    ];

    return (
      <div className={"page"}>
        <div className="d-flex justify-content-between mb-3">
          <div
            style={{
              width: "160px",
              borderBottom: "1px solid black",
              textAlign: "center",
            }}
          >
            <h5>Manage Staff</h5>
          </div>
          <Link to="/staff-new" className="link-light text-decoration-none">
            <button
              title="Add device item"
              className="k-btn k-btn-primary k-btn-sm"
            >
              Add New Staff
            </button>
          </Link>
        </div>

        <div className={"pageContent clearfix"}>
          <div className={"admin-table-container"}>
            <Table
              head={tableHead}
              protectedFetch={this.props.protectedFetch}
            />
          </div>
        </div>
      </div>
    );
  }
}
